import { get } from "lodash";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { NAVIGATION_DIRECTIONS } from "utils/constants";
import View from "./View";

const Deactivate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => {
    navigate(NAVIGATION_DIRECTIONS.BACK, { replace: true });
  };
  const [updateProjects] = useMutation(graphql.mutations.UPDATE_PROJECTS, {
    variables: { where: { author: { id } }, data: { author: null } },
  });

  const [updateUser] = useMutation(graphql.mutations.UPDATE_USER, {
    refetchQueries: [
      {
        query: graphql.queries.USERS,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      setVisible(false);
      navigate(NAVIGATION_DIRECTIONS.BACK, { replace: true });
    },
    onError: () => {},
  });
  const { data, loading, error } = useQuery(graphql.queries.USER, {
    variables: { where: { id } },
  });

  const onSubmit = () => {
    updateProjects();
    return updateUser({
      variables: {
        where: {
          id,
        },
        data: {
          isActive: false,
        },
      },
    });
  };
  if (loading || error) return <Loading />;

  return (
    <View
      onSubmit={onSubmit}
      cancel={cancel}
      visible={visible}
      userType={get(data, "user.meta.type")}
      polesId={get(data, "user.poles", []).map(({ id }) => id)}
      userName={`${get(data, "user.firstname")} ${get(data, "user.lastname")}`}
    />
  );
};

export default Deactivate;
